type Variant = 'primary' | 'secondary' | 'tertiary' | 'neutral';

interface HeadlineProps {
  text: string;
  variant?: Variant;
  noBottomMargin?: boolean;
}

const Headline = ({ text, variant = 'primary', noBottomMargin = false }: HeadlineProps) => {
  const variantStyleSets: Record<Variant, string> = {
    primary: '',
    secondary: 'text-secondary',
    tertiary: 'text-tertiary',
    neutral: 'text-neutral',
  };

  return <h1 className={`tc-headline ${variantStyleSets[variant]} ${noBottomMargin ? 'mb-0' : ''}`}>{text}</h1>;
};

export default Headline;
